"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Lernik Mirzoyan.
 * Created on 2019-03-01.
 */
var PeriodGeneratorService = /** @class */ (function () {
    function PeriodGeneratorService() {
    }
    return PeriodGeneratorService;
}());
exports.PeriodGeneratorService = PeriodGeneratorService;
//# sourceMappingURL=period-generator.service.js.map